"use strict";

var _regeneratorRuntime = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intervalUtils = void 0;
exports.intervalUtils = {
  setAsyncExcludingInterval: function setAsyncExcludingInterval(fn, intervalMs, onError) {
    var _this = this;

    var isLocked = false;
    var intervalId = setInterval(function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!isLocked) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                isLocked = true;
                _context.prev = 5;
                _context.next = 8;
                return fn();

              case 8:
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](5);
                onError(_context.t0);

              case 13:
                isLocked = false;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 10]]);
      }));
    }, intervalMs);
    return intervalId;
  },
  clearAsyncExcludingInterval: function clearAsyncExcludingInterval(intervalId) {
    clearInterval(intervalId);
  },
  setInterval: function (_setInterval) {
    function setInterval(_x, _x2, _x3) {
      return _setInterval.apply(this, arguments);
    }

    setInterval.toString = function () {
      return _setInterval.toString();
    };

    return setInterval;
  }(function (fn, intervalMs, onError) {
    var intervalId = setInterval(function () {
      try {
        fn();
      } catch (err) {
        onError(err);
      }
    }, intervalMs);
    return intervalId;
  }),
  clearInterval: function (_clearInterval) {
    function clearInterval(_x4) {
      return _clearInterval.apply(this, arguments);
    }

    clearInterval.toString = function () {
      return _clearInterval.toString();
    };

    return clearInterval;
  }(function (intervalId) {
    clearInterval(intervalId);
  })
};